module.exports = __webpack_public_path__ + "img/white_paper13.b7f217e1.png";